import * as React from 'react';
import { Link } from 'react-router-dom';
import formatAsUpperFirst from '../../../../../logic/functions/common/formatAsUpperFirst';
import searchTestIds from '../../SearchResults.elements';
import * as Styled from './styled';

interface Props {
	name: string;
	id?: string;
	token?: string;
	type?: string;
}

const ItemDetails: React.FunctionComponent<Props> = ({
	id,
	token,
	type,
	name,
}) => {
	React.useEffect(() => {}, [id]);
	const linkProp =
		type && type == 'plan' ? (
			<Styled.RouterLink to={`/planProfile/${token}`}>
				{formatAsUpperFirst(name)}
			</Styled.RouterLink>
		) : (
			<Styled.Name
				href={`/online/adviser/${type}profile/${id}?executeback=search?back=true`}
				data-id={searchTestIds.clientName}
			>
				{formatAsUpperFirst(name)}
			</Styled.Name>
		);
	return (
		<React.Fragment>
			{linkProp}
			<div>
				<Styled.OtherDetails data-id={searchTestIds.clientNumber}>
					{id}
				</Styled.OtherDetails>
			</div>
		</React.Fragment>
	);
};

export default ItemDetails;
